import React, { Component, PropTypes } from 'react';

export default class MultilpleEmailField extends Component {
    static propTypes = {
        val: PropTypes.string,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {
        this.setState({
            val: this.props.val
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleEmailInputChange = (e) => {
        this.setState({
            val : e.target.value
        }, (e) => {
            let emailAddress = this.state.val;

            this.props.updateEmailArray(this.props.index, emailAddress);
        });
    };

    render() {
        var className = this.state.val ? 'form-control emailInput edited' : 'form-control emailInput';

        var buttonColor = "red removeEmail"
        var buttonClassname = "fa fa-times removeEmail";

        if (this.props.index === this.props.totalIndex - 1) {
            buttonColor = "blue addEmail";
            buttonClassname = 'fa fa-plus addEmail';
        }

        return (
            <div className="form-group form-md-line-input form-md-floating-label perContainer" data-index={this.props.index}>
                <div className="input-group">
                    <div className="input-group-control">
                        <input type="text" className={className} id={this.props.id}
                           name={this.props.id} onChange={this.handleEmailInputChange}
                           value={this.state.val} />
                        <label htmlFor={this.props.id}>{this.props.label}</label>
                    </div>
                    <span className="input-group-btn btn-right">
                        <a href="#" className={"btn btn-circle btn-icon-only " + buttonColor}>
                            <i className={buttonClassname}/>
                        </a>
                    </span>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/MultipleEmailField.js
 **/